__turbopack_context__.v({
  "arrow": "_B9b1W_arrow",
  "arrowNext": "_B9b1W_arrowNext",
  "arrowPrev": "_B9b1W_arrowPrev",
  "dot": "_B9b1W_dot",
  "dotActive": "_B9b1W_dotActive",
  "dots": "_B9b1W_dots",
  "image": "_B9b1W_image",
  "placeholder": "_B9b1W_placeholder",
  "slide": "_B9b1W_slide",
  "track": "_B9b1W_track",
});
